import React from "react";
import styleSheet from "./style.module.scss";
import { useSelector } from "react-redux";
import { getLoadingDetails } from "../../../feature/loading-slice";

import sun from "../../../asset/sun.png";
import ufo from "../../../asset/ufo.png";

const PlanetLoader = () => {
  const loadingInfo = useSelector(getLoadingDetails);

  return (

    loadingInfo.fetchLoading && (
    <div className={styleSheet.fullscreenWrapper}>
      <div className={styleSheet.content}>
        <div className={styleSheet.planetWrapper}>
          <img src={sun} alt="planet" className={styleSheet.sunImg} />
          <div className={`${styleSheet.ufoOrbit}`}>
            <div className={styleSheet.ufoCarrier}>
              <img src={ufo} alt="ufo" className={styleSheet.ufoImg} />
            </div>
          </div>
        </div>
      </div>
    </div>
    )
  //  <div className={styleSheet.loaderOverlay}>
  //     <span className={styleSheet.loader}></span>
    
  //   </div>

  );
};

export default PlanetLoader;
